/**
 * The single default profile picture used across the whole app.
 *
 * Every user who has not uploaded a picture - and every user right after they
 * remove theirs - shows this image, both online and offline.
 *
 * It is bundled into the build (and therefore precached by the service worker
 * via `precacheAndRoute(self.__WB_MANIFEST)`), so it is ALWAYS available even
 * offline and never degrades to MUI's single-letter fallback. The identical
 * image also lives in Azure at `user-profile-picture/default-image/display.jpg`
 * as the canonical stored copy; if you ever change the default, update both.
 *
 * There is intentionally exactly ONE default here; components must not fall
 * back to the old per-page hardcoded avatars (avatar-1.png / default.png).
 */
import defaultProfile from 'assets/images/users/default-profile.jpg';

export const DEFAULT_AVATAR = defaultProfile;

export default DEFAULT_AVATAR;
